import { StoreError } from "@/components/StoreComponents/StoreError";
import { useAppSelector } from "@/redux/hooks";
import { styled } from "@mui/material";
import { useCheckoutUI } from "../../CheckoutUIProvider";

const CartContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  textAlign: "left",
  gap: "16px",
  ".terms": {
    width: "100%",
    textAlign: "left",
    fontSize: 12,
    [theme.breakpoints.down("sm")]: {
      fontSize: 10,
    },
    opacity: 0.3,
    ".tosLinks": {
      color: "unset",
      "&:visited": {},
    },
  },
}));

export const RetailerErrorAndTerms = () => {
  const [state] = useCheckoutUI();
  const { checkoutIntent } = state.context;

  const checkoutError = state.context.checkoutResponse?.errorMessage;
  const currentRetailer = useAppSelector((state) => state.retailers).find(
    (item) => item.retailerId === checkoutIntent?.retailerId
  );
  const termsAndService = currentRetailer?.tosUrl;

  return (
    <CartContainer>
      <div className="terms">
        By ordering, you agree to the {currentRetailer?.displayName}{" "}
        <a
          href={termsAndService?.terms}
          target="_blank"
          rel="noreferrer"
          className="tosLinks"
        >
          Terms
        </a>{" "}
        and{" "}
        <a
          href={termsAndService?.policies}
          target="_blank"
          rel="noreferrer"
          className="tosLinks"
        >
          Privacy Policy
        </a>
        {""}.
      </div>
      {checkoutError && <StoreError errorMessage={checkoutError} />}
    </CartContainer>
  );
};
